import src from "IMAGE";
export default { src, width: 971, height: 270, blurWidth: 0, blurHeight: 0};
